import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { countiesInitialState, ICountiesData } from './interfaces';
import { eUSAState } from '../../ui-toolkit/enums/states';
import { ICountyData } from '../../ui-toolkit/orders/searchOrder/types/ICounty';

export const countiesSlice = createSlice({
  name: 'counties',
  initialState: countiesInitialState,
  reducers: {
    setCountiesAction: (state, action: PayloadAction<ICountiesData>) => {
      state.counties = action.payload;
    },
    setCountyAction: (state, action: PayloadAction<{ state: eUSAState; counties: ICountyData[] }>) => {
      state.counties[action.payload.state] = action.payload.counties;
    },
    setCountiesFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.countiesFetchStatus = action.payload;
    },
    setCountiesErrorAction: (state, action: PayloadAction<string | null>) => {
      state.countiesError = action.payload;
    },
  },
});
export const { setCountiesAction, setCountyAction, setCountiesFetchStatusAction, setCountiesErrorAction } =
  countiesSlice.actions;
